export const queryKeys = {
  KPI_CONFIG: 'KPI_CONFIG'
};
